import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template8.css";
import "./CheckoutTemplate8.css";

/*
   Checkout Template 8 — a seamless continuation of sales Template 8 ("Bold
   Minimal", premium light). Reuses Template8.css directly (same .clp8-root
   design system): the real .b8-nav, the big centered .b8-hero with its
   .b8-title, the .b8-btn.b8-btn-p button and .b8-foot footer. Only the form +
   order summary rows are checkout-specific (CheckoutTemplate8.css), styled to
   match the template's borderless, card-less editorial look.
*/
export default function ThankYouTemplate8({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp8-root">
      {/* NAV — same as the sales page */}
      <nav className="b8-nav scr">
        <div className="b8-wrap b8-nav-in">
          <a href="#top" className="b8-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok8-brandtext">{c.brand}</span>}
          </a>
          <span className="cok8-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales big-type hero */}
      <header className="b8-hero cok8-hero" id="top">
        <div className="b8-wrap b8-hero-in">
          <span className="cok8-eyebrow">Thank you</span>
          <h1 className="b8-title">
            You're <span className="cok8-accent">enrolled</span>
          </h1>
          {c.sub ? <p className="b8-sub">{c.sub}</p> : null}
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's editorial style */}
      <div className="b8-wrap">
        <ThankYouBody data={data} p="cok8" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="b8-foot">
        <div className="b8-wrap">
          <div className="cok8-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
